import React, { Fragment } from 'react';
import { SupportedFeatures } from 'data/supportedFeatures/supportedFeatures.types';
import i18n from 'i18n';
import { CspConfig } from 'data/cspConfig/cspConfig.types';
import { getCspIdFromUserTeams } from 'teams/utils/cspAdminUtils';
import WarrantGrid from './grid';
import './warrants.scss';
import { AppToaster } from '../../shared/toaster';
import WarrantConfiguration from '../config/warrant-config';

type WarrantFrameProps = {
  authentication: any
  users?: { teams?: { cspid?: string | null }[] }
  isMultitenantEnabled?: boolean
  cspConfigs?: CspConfig[]
  getCspConfigList: (deliveryFunctionId: string) => Promise<any>
  global: {
    selectedDF: string
  }
  getAllTemplates: any
  getAllContacts: any
  getUserTeams: any
  getWarrantFormCustomizationConfig: any
  getWarrantFormConfig: any
  setWarrantConfigInstance: any
  getTimezones: any
  getDivisions: any
  getCollectionFunctionGroupList: any
  warrants: {
    config: SupportedFeatures
    error: any
  }
  clearErrors: any
  history: any
  fetchCollectionFunctionList: (deliveryFunctionId: string) => Promise<any>
  fetchCollectionFunctionListByFilter: (deliveryFunctionId: string, filter: string) => Promise<any>
  getAllAFsByFilter: (deliveryFunctionId: string, filter: string) => Promise<any>
  discoveryXcipio: {
    discoveryXcipioSettings: {
      deployment: string,
      'singlepointprovisioning.enabled': boolean,
    }
  },
}

type WarrantFrameState = {
  selectedTab: string
  selectedView: string
  viewType: string
}

class WarrantFrame extends React.Component<WarrantFrameProps, WarrantFrameState> {
  private gridRef: any;

  constructor(props: WarrantFrameProps) {
    super(props);
    this.gridRef = React.createRef();
    this.state = {
      selectedTab: 'events',
      selectedView: 'grid',
      viewType: 'split',
    };
  }

  handleChange = (e: any) => {
    this.setState({ selectedTab: e });
  }

  handleViewChange = (e: any) => {
    this.setState({ selectedView: e.currentTarget.id });
  }

  handleNavViewChange = (value: string) => {
    this.setState({ viewType: value });
  }

  handleAction = () => {
  }

  componentDidMount() {
    const { userId } = this.props.authentication;
    const { selectedDF: dfId } = this.props.global;
    this.props.getAllTemplates();
    this.props.getAllContacts(dfId);
    const userTeamsLoaded = this.props.getUserTeams(userId);
    this.props.getWarrantFormCustomizationConfig(dfId);
    // The user's CSP comes from their teams, so the AF list can only be filtered once both are in.
    const cspConfigsLoaded = this.props.getCspConfigList(dfId);
    Promise.all([this.props.getWarrantFormConfig(dfId), userTeamsLoaded, cspConfigsLoaded]).then(() => {
      this.props.setWarrantConfigInstance(new WarrantConfiguration({
        ...this.props,
        userCspId: getCspIdFromUserTeams(this.props.users?.teams),
      }));
    });
    this.props.getTimezones();
    this.props.getCollectionFunctionGroupList(dfId);
    this.props.fetchCollectionFunctionList(dfId);
  }

  componentDidUpdate(prevProps: WarrantFrameProps) {
    const { error } = this.props.warrants;
    if (error) {
      AppToaster.show({
        icon: 'error',
        intent: 'danger',
        timeout: 0,
        message: i18n.t('common.toast.error', { error }),
      });
      this.props.clearErrors();
    }
    if (!this.props.authentication.isAuthenticated) {
      this.props.history.push('/authentication/login');
    }

    const isPrevSinglePointProvisioningEnabled = prevProps.discoveryXcipio.discoveryXcipioSettings?.['singlepointprovisioning.enabled'];
    const { discoveryXcipioSettings } = this.props.discoveryXcipio;
    const isSinglePointProvisioningEnabled = discoveryXcipioSettings?.['singlepointprovisioning.enabled'];
    if (!isPrevSinglePointProvisioningEnabled && isSinglePointProvisioningEnabled) {
      this.props.getDivisions();
    }
  }

  componentWillUnmount() {
    this.props.clearErrors();
  }

  render() {
    return (
      <Fragment>
        <div className="col-md-12" style={{ height: 'inherit' }}>
          <WarrantGrid ref={this.gridRef} {...this.props} />
        </div>
      </Fragment>
    );
  }
}

export default WarrantFrame;
